import { START_DRAG } from '../constants';

export default function startDrag(domainName, dragType, dragData) {
  return {
    type: START_DRAG,
    domainName,
    dragType,
    dragData,
  };
}
